import { BasePage } from '../BasePage'
import { MainTitle } from '@/components/title/MainTitle'

export const Top = () => {
  return (
    <BasePage title="トップページ">
      <MainTitle>トップページ</MainTitle>
    </BasePage>
  )
}
